// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3_L78","filesListContainer":"PosDisputesFiles_filesListContainer__2P-iK","filesButton":"PosDisputesFiles_filesButton__3xqRd"};